export default (values) => {
  const errors = {};

  if (values?.name?.length === 0) errors.name = true;

  return errors;
};
